import React, { memo } from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { useAppButton } from "./index.hooks";

export type AppButtonProps = {
  loading?: boolean;
  absolutePath?: boolean;
  path?: string;
} & ButtonProps;

export const AppButton = memo(
  ({
    loading = false,
    absolutePath = false,
    path,
    onClick,
    children,
    sx,
    ...props
  }: AppButtonProps) => {
    const { onButtonClicked } = useAppButton(path, absolutePath, onClick);

    return (
      <Button
        sx={[
          // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
        onClick={onButtonClicked}
      >
        {loading ? (
          <CircularProgress
            color={
              (props.color ?? "primary") === "primary" ? "secondary" : "primary"
            }
            size={16}
          />
        ) : (
          children
        )}
      </Button>
    );
  },
);
